import React, { useEffect, useState } from "react";
import "./Vantagens.scss";
import Grid from "@mui/material/Grid";
import IconeAtivo from "../../../assets/images/home/icone_ativo.png";
import IconeInativo from "../../../assets/images/home/icone_inativo.png";
import Linha from "../../../assets/images/home/linha.png";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";

const Vantagens = () => {
  const [icone, setIcone] = useState(1);
  const [mouse, setMouse] = useState(false);


  useEffect(() => {
    Aos.init({ duration: 2000 });

    const interval = setInterval(() => {
      if (mouse) return;
      setIcone(() => {
        if (icone === 5) {
          return 1;
        } else {
          return icone + 1;
        }
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [icone, mouse]);

  return (
    <>
      <div className="view-vantagens">
        <Container>
          <div data-aos="fade-up" className="titulo">
            VANTAGENS DE SER <span>#BUPIN</span>
          </div>
          <div className="grid-icones">
            <Grid container spacing={0} justifyContent="center">
              <Grid item md={1}>
                <div data-aos="fade-up" className="icone">
                  <img
                    src={icone === 1 ? IconeAtivo : IconeInativo}
                    onMouseEnter={() => {
                      setIcone(1);
                      setMouse(true);
                    }}
                    onMouseLeave={() => {
                      setMouse(false);
                    }}
                    alt="icone-ativo"
                  />
                </div>
                <div data-aos="fade-up" className="texto">
                  Agilidade e Segurança para fazer seus orçamentos
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="linha">
                  <img src={Linha} alt="Linha" />
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="icone">
                  <img
                    src={icone === 2 ? IconeAtivo : IconeInativo}
                    onMouseEnter={() => {
                      setIcone(2);
                      setMouse(true);
                    }}
                    onMouseLeave={() => {
                      setMouse(false);
                    }}
                    alt="icone-ativo"
                  />
                </div>
                <div data-aos="fade-up" className="texto">
                  Simulação em tempo real para seu cliente
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="linha">
                  <img src={Linha} alt="Linha" />
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="icone">
                  <img
                    src={icone === 3 ? IconeAtivo : IconeInativo}
                    onMouseEnter={() => {
                      setIcone(3);
                      setMouse(true);
                    }}
                    onMouseLeave={() => {
                      setMouse(false);
                    }}
                    alt="icone-ativo"
                  />
                </div>
                <div data-aos="fade-up" className="texto">
                  Controle completo de fluxo de trabalho da sua empresa
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="linha">
                  <img src={Linha} alt="Linha" />
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="icone">
                  <img
                    src={icone === 4 ? IconeAtivo : IconeInativo}
                    onMouseEnter={() => {
                      setIcone(4);
                      setMouse(true);
                    }}
                    onMouseLeave={() => {
                      setMouse(false);
                    }}
                    alt="icone-ativo"
                  />
                </div>
                <div data-aos="fade-up" className="texto">
                  Segurança no armazenamento dos seus dados
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="linha">
                  <img src={Linha} alt="Linha" />
                </div>
              </Grid>
              <Grid item md={1}>
                <div data-aos="fade-up" className="icone">
                  <img
                    src={icone === 5 ? IconeAtivo : IconeInativo}
                    onMouseEnter={() => {
                      setIcone(5);
                      setMouse(true);
                    }}
                    onMouseLeave={() => {
                      setMouse(false);
                    }}
                    alt="icone-ativo"
                  />
                </div>
                <div data-aos="fade-up" className="texto">
                  Sistema de controle financeiro completo
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="botao-planos">
            <Link to="/produtos">
              <button>CONHEÇA NOSSOS PLANOS</button>
            </Link>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Vantagens;
